import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';
import Tooltip from 'shopper/components/Tooltip';

import UserAvatar from 'components/UserAvatar';

import placeholder from 'lib/placeholder';
import { toUsernameWithAtSign } from 'lib/user';

const UserProfileInfo = ({
  className,
  userId,
  userName = null,
  userPhoto = null,
  userTypeName = null,
  userUsername,
  isReview = false,
}) => (
  <div className={twJoin('flex items-center gap-x-2', className)}>
    <UserAvatar
      description={userName ? placeholder('errors.userNotFound') : null}
      size="size6"
      userId={userId}
      userName={userName}
      userPhoto={userName ? userPhoto : null}
      userTypeName={userTypeName}
      userUsername={userUsername}
      asLink
    />
    <Text
      className="max-w-32 overflow-hidden text-ellipsis text-neutral-low-400 dark:text-neutral-high-200 md:w-unset"
      size="size3"
      bold
    >
      {userName
        ? toUsernameWithAtSign(userUsername)
        : placeholder('errors.userNotFound')}
    </Text>
    {isReview && (
      <Tooltip.Root>
        <Tooltip.Trigger>
          <Icon
            className="text-rd-primary-700"
            name="rating-star"
            size="size3"
          />
        </Tooltip.Trigger>
        <Tooltip.Box className="w-40 rounded-4 bg-rd-primary-100 dark:bg-rd-primary-300 [&_span]:text-neutral-low-300">
          {placeholder('tips.thisCommentIsAReview')}
        </Tooltip.Box>
      </Tooltip.Root>
    )}
  </div>
);

UserProfileInfo.propTypes = {
  className: PropTypes.string,
  userId: PropTypes.number,
  userName: PropTypes.string,
  userPhoto: PropTypes.string,
  userTypeName: PropTypes.string,
  userUsername: PropTypes.string,
  isReview: PropTypes.bool,
};

export default UserProfileInfo;
